import styled from "@emotion/styled";
import { Color } from "../../../../Theme";
var CardContainer = /*#__PURE__*/ styled("div", {
    target: "e1lk39vp0"
})("&:empty{display:none;}&:not(:empty){border:", function(param) {
    var hasBorder = param.hasBorder;
    return hasBorder ? "1px solid ".concat(Color.natural50) : 0;
}, ";border-radius:1px;container-type:inline-size;}");
export { CardContainer };
